import { Search, X } from 'lucide-react'

interface FavoritesSearchProps {
  searchQuery: string
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClearSearch: () => void
}

const FavoritesSearch = ({
  searchQuery,
  onSearchChange,
  onClearSearch,
}: FavoritesSearchProps) => {
  return (
    <div className="profile-search-bar">
      <div className="search-input-container">
        <input
          type="text"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Поиск по избранным карточкам..."
          className="search-input"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={onClearSearch}
            className="clear-button"
            aria-label="Очистить поиск"
          >
            <X />
          </button>
        )}
        <div className="search-icon">
          <Search />
        </div>
      </div>
    </div>
  )
}

export default FavoritesSearch
